import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChargeFormComponent } from './charge-form/charge-form.component';
import { ChargeListComponent } from './charge-list/charge-list.component';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChargeRoutingModule } from './charge-routing.module';



@NgModule({
  declarations: [
    ChargeFormComponent,
    ChargeListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    ChargeRoutingModule
  ]
})
export class ChargeModule { }
